import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { MsalBroadcastService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { filter, map, take } from 'rxjs/operators';
import { TokenService } from './token.service';
import { UserRole } from './user-role.enum';

export const keycloakUserManagementGuard: CanActivateFn = () => {
  const tokenService = inject(TokenService);
  const router = inject(Router);
  const msalBroadcastService = inject(MsalBroadcastService);

  return msalBroadcastService.inProgress$.pipe(
    filter((status: InteractionStatus) => status === InteractionStatus.None),
    take(1),
    map(() => {
      if (tokenService.hasRole(UserRole.BACKOFFICE_ADMIN)) {
        return true;
      }
      return router.createUrlTree(['/order']);
    })
  );
};
